import axios from '@/utils/http';

export default () => {
  return axios
    .get('/settings')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
